export default {
  initializeNewMember(state) {
    // Initialize an object that for each of our joinQuestions, has an empty string response.
    const blankResponsesToJoinQuestions = Object.fromEntries(
      state.joinQuestions.map(({ slug }) => [slug, ''])
    )

    state.newMember = {
      additionalFieldValues: {},
      dataProcessingConsent: null,
      newMemberQuestionResponses: blankResponsesToJoinQuestions,
      notificationLevel: state.defaultNotificationLevel,
      validationErrors: {}
    }
  },

  setDataProcessingConsentProps(state, newValue) {
    state.dataProcessingConsentProps = newValue
  },

  setNewMemberValidationErrors(state, errors) {
    state.newMember.validationErrors = errors
  },

  setUserHasPendingJoinRequest(state, newValue) {
    state.userHasPendingJoinRequest = newValue
  },

  setUserIsLoggedIn(state, newValue) {
    state.userIsLoggedIn = newValue
  },

  updateNewMemberAdditionalField(state, { field, value }) {
    state.newMember.additionalFieldValues[field] = value
  },

  updateNewMemberField(state, { field, value }) {
    state.newMember[field] = value
  },

  updateNewMemberQuestionResponse(state, { slug, value }) {
    state.newMember.newMemberQuestionResponses[slug] = value
  }
}
